import { hasPermission } from "../authentication/authorizeNavigation";

export const filterMenu = (menuItems) => {
    return menuItems
        .map(section => {
            const filteredItems = section.items
                .map(item => {
                    // profile items: keep as-is (no security key assumed)
                    if (item.profile) return { ...item };

                    // If there's a securityKey on the parent and user lacks permission -> drop item
                    if (item.securityKey && !hasPermission(item.securityKey)) return null;

                    // If subMenu exists, filter its children
                    if (item.subMenu) {
                        const filteredSub = item.subMenu.filter(sub => {
                            // if sub has no securityKey, keep it; otherwise check permission
                            return !sub.securityKey || hasPermission(sub.securityKey);
                        });

                        // If the original subMenu is a "blank" type (first child has blank flag),
                        // keep the parent even if filteredSub is empty — preserve existing blank behavior.
                        const isBlank = !!item.subMenu[0]?.blank;

                        if (filteredSub.length === 0 && !isBlank) {
                            // nothing allowed for this sub-menu and it's not a blank type -> drop parent
                            return null;
                        }

                        // return parent with filtered subMenu (may be empty if blank)
                        return { ...item, subMenu: filteredSub };
                    }

                    // no subMenu, and permission (if any) passed -> keep item
                    return { ...item };
                })
                .filter(Boolean); // remove nulls

            return { ...section, items: filteredItems };
        })
        // remove sections with no items after filtering
        .filter(section => Array.isArray(section.items) && section.items.length > 0);
};